import { LoadingState } from 'components/LoadingStateUtil';

export function getEmptyGridText(rowCount: number, loadingState?: LoadingState) {
  return (loadingState === undefined || loadingState.status === 'Complete') && rowCount === 0 ? 'No rows' : '';
}
